import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    keyword_btn: {
      minWidth: 19,
      minHeight: 19,
      width: 19,
      height: 19,
      background: 'none',
      border: 0,
      padding: 0,
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      cursor: 'pointer',
      '& svg:first-of-type': {
        width: '100%',
        height: '100%',
      },
      '&:hover': {
        opacity: 0.7,
      },
    },
    filter: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%) scale(0.6)',
      width: 19,
      height: 19,
      stroke: 'rgb(26, 0, 99)',
    },
  })
)
export default useStyles
